import React from 'react';

import Certificate from 'commons/Certificate';
import useResizeCertificate from 'hooks/useResizeCertificate';

const CertificateAutoView = ({
  artwork,
  certificate,
  scaleMode = 'xAxis',
  isShowButtonDownloadCertificate,
  rootStyle,
  autoOpenDownload,
}) => {
  const { getRootProps, getParentProps, getCertificateProps, resizeStyle } =
    useResizeCertificate(scaleMode);

  return (
    <div
      {...getRootProps()}
      className={rootStyle}
    >
      <div {...getParentProps()}>
        <Certificate
          {...getCertificateProps()}
          artwork={artwork}
          certificate={certificate}
          isShowButtonDownloadCertificate={isShowButtonDownloadCertificate}
          wrapperInlineStyle={resizeStyle}
          autoOpenDownload={autoOpenDownload}
        />
      </div>
    </div>
  );
};

export default CertificateAutoView;
